import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { PbsAdUnit } from '@pubstack/common/src/pbs/adunit'
import { FunctionComponent } from 'react'
import { Colors } from '~/assets/style/colors'
import { Fonts } from '~/assets/style/fonts'
import { WithClassName } from '~/types/utils'

const Card = styled.div`
  background-color: ${Colors.White};
  width: 184px;
  border-radius: 4px;
  position: sticky;
  top: 20px;
`

const Content = styled.div`
  padding: 12px 6px 12px 10px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const Label = styled.span<{ isDefined: boolean }>`
  ${Fonts.P3};
  text-overflow: ellipsis;
  overflow: hidden;
  ${({ isDefined }) =>
    !isDefined &&
    css`
      color: ${Colors.Ash};
      font-style: italic;
    `}
`

const Title = styled.div`
  ${Fonts.H2};
`
const SubTitle = styled.div`
  ${Fonts.P2};
  font-weight: 700;
`
const Block = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export type SummaryCardProps = WithClassName & {
  adUnit: PbsAdUnit
}

const BaseSummaryCard: FunctionComponent<SummaryCardProps> = ({ className, adUnit }) => {
  return (
    <Card className={className}>
      <Content>
        <Title>Summary</Title>
        <Block>
          <SubTitle>Identification</SubTitle>
          <Label isDefined={!!adUnit.name}>{adUnit.name ? adUnit.name : 'Name'}</Label>
        </Block>
        <Block>
          <SubTitle>Format</SubTitle>
          <Label isDefined={!!adUnit.adFormat}>{adUnit.adFormat ? adUnit.adFormat.name : 'Not selected'}</Label>
        </Block>
      </Content>
    </Card>
  )
}

export const SummaryCard = styled(BaseSummaryCard)``
